"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.membershipRequestFactory = exports.membershipRequestExistingMembershipFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const mocks_1 = require("../../../mocks");
exports.membershipRequestExistingMembershipFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => uuid_1.v4()),
    membership_request_id: Factory.each(i => uuid_1.v4()),
    existing_membership_id: Factory.each(i => uuid_1.v4()),
    created_at: mocks_1.dates.date2000,
    existing_membership_persona_id: mocks_1.persona.id,
    existing_membership_status: 'Active',
    existing_membership_is_obo: true,
    existing_membership_boss_organization_id: mocks_1.orgNgb.id,
    existing_membership_affiliation_organization_id: mocks_1.orgClub.id,
});
exports.membershipRequestFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => uuid_1.v4()),
    requested_membership_id: Factory.each(i => uuid_1.v4()),
    status: 'approval_needed',
    created_at: mocks_1.dates.date2000,
    updated_at: mocks_1.dates.date2000,
    requesting_persona_id: mocks_1.persona.id,
    membership_definition_id: Factory.each(i => uuid_1.v4()),
    requested_membership_is_obo: true,
    requested_membership_persona_id: mocks_1.persona.id,
    requested_membership_status: 'Requested',
    requested_membership_boss_organization_id: mocks_1.orgNgb.id,
    requested_membership_affiliation_organization_id: mocks_1.orgClub.id + 1,
    membership_request_existing_memberships: exports.membershipRequestExistingMembershipFactory.buildList(1)
});
